import {FC, useCallback} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {useNavigate} from "react-router-dom";
import {LessonsListGrid} from "./LessonsListGrid";

const useStyles = makeStyles()((theme) => ({
	adminLessonsList: {
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		},
		"& svg path": {
			fill: theme.palette.common.white
		}
	}
}));

/**
 * Admin Lessons List (App2)
 *
 * Uses useListLessons and DataGridPro; same layout/styles as original.
 */
export const AdminLessonsList: FC = () => {
	const {classes} = useStyles();
	const navigate = useNavigate();

	const onCreateClick = useCallback(() => {
		navigate("create-new");
	}, [navigate]);

	return (
		<Box className={classes.adminLessonsList}>
			<AdminHeader
				title="Lessons"
				subtitle="Manage lessons"
				actionButtons={[{label: "Create New", onClick: onCreateClick}]}
			/>
			<LessonsListGrid />
		</Box>
	);
};
